
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".997","width":"18","height":"18","rx":"4","fill":"#EBEBEB"}}),_c('path',{attrs:{"d":"M6.448 13.935a.617.617 0 01-.434-.154.549.549 0 01-.154-.406v-8.75c0-.168.052-.303.154-.406a.617.617 0 01.434-.154h2.73c1.578 0 2.796.43 3.654 1.288.868.85 1.302 2.063 1.302 3.64s-.434 2.795-1.302 3.654c-.868.859-2.086 1.288-3.654 1.288h-2.73zm2.66-.98c2.558 0 3.836-1.32 3.836-3.962 0-2.632-1.278-3.948-3.836-3.948h-2.1v7.91h2.1z","fill":"#313131"}})])
          )
        }
      }
    